import { OverlayPanel as PrimeOverlayPanel } from "primereact/overlaypanel";
import React from "react";
import useStyle from "./useStyle";
import cssUtils from "utils/cssUtils";

export type Checked = boolean | "mixed";

export interface OverlayPanelProps {
  onOpen?: () => void;
  onHide?: () => void;

  buttonTitle: string;
  buttonIcon: string;

  style?: object | undefined;
  buttonStyle?: object | undefined;
  className?: string | undefined;
}

const OverlayPanel: React.FC<OverlayPanelProps> = function (props) {
  const classes = useStyle(props);
  let primeOverlayPanelRef: PrimeOverlayPanel | null = null;
  // PrimeReact renders overlay children into the DOM eagerly, even while the
  // panel is closed. For heavy content (e.g. a filter list with thousands of
  // values) that means the full render cost is paid on every parent
  // render/mount. Defer mounting the children until the panel is first opened,
  // then keep them mounted so selection/scroll state is preserved.
  const [hasOpened, setHasOpened] = React.useState(false);

  return (
    <div>
      <i
        className={cssUtils.join(
          classes.button,
          props.buttonIcon,
          props.className
        )}
        style={props.buttonStyle}
        onClick={(e) => {
          if (!hasOpened) {
            setHasOpened(true);
          }
          primeOverlayPanelRef && primeOverlayPanelRef.toggle(e);
          props.onOpen && props.onOpen();
        }}
      />
      <PrimeOverlayPanel
        ref={(el) => (primeOverlayPanelRef = el)}
        onHide={() => props.onHide && props.onHide()}
        style={props.style}
        appendTo={document.body}
      >
        {hasOpened ? props.children : null}
      </PrimeOverlayPanel>
    </div>
  );
};

export default OverlayPanel;
